import { Button, message, Upload } from 'antd';
import React from 'react';
import { API_URL, MAIN_URL } from '../../../Constants';

function FileUpload({setUserImg}) {

    const props = {
        name: 'image',
        action: API_URL + '/file',
        headers: {
            authorization: 'authorization-text',
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                setUserImg(MAIN_URL + '/' + info.file.response.data.image)
            }
            if (info.file.status === 'done') {
                message.success(`${info.file.name} file uploaded successfully`);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
    };

    return (
        <>
            <Upload {...props}>
                <Button>Faylni Yuklash</Button>
            </Upload>
          
        </>
    );
}

export default FileUpload;